import React, { useMemo } from 'react'
import LocationFeaturedCenters from './LocationFeaturedCenters'
import { ZoneIds } from '../../domain/zoneIds'
import { MIN_FEATURED_CENTERS } from '../../domain/browseBy/constants'
import {
  isFacetPageType,
  isLocationPageType
} from '../../domain/useCases/pageTypeCheck'
import type { CenterFeed, PageType, Term } from '@/types/models'

const LocationFeaturedCentersCarousel = ({
  pageType,
  title,
  nationalFeaturedCenters,
  featuredCentersLoading,
  termData,
  feedPosition,
  titleOveride
}: {
  pageType: PageType
  title: string
  nationalFeaturedCenters: CenterFeed[]
  featuredCentersLoading: boolean
  termData: Term
  feedPosition: number
  titleOveride?: string
}): JSX.Element | null => {
  const isValidPageType =
    isFacetPageType(pageType) || isLocationPageType(pageType)

  if (
    !isValidPageType ||
    nationalFeaturedCenters?.length < MIN_FEATURED_CENTERS
  ) {
    return null
  }
  return (
    <div className="mt-8">
      <LocationFeaturedCenters
        featuredCentersLoading={featuredCentersLoading}
        feedPosition={feedPosition}
        centers={nationalFeaturedCenters}
        ZoneIds={ZoneIds}
        term={termData}
        locationTitle={title || titleOveride}
        containerId="nationwideFeatured"
        sectionHeading="Destination Centers Matching Your Care Options"
        withGradient={true}
        noPadding={true}
        isInfeed={true}
        pageType={pageType}
        isNationwide={true}
      />
    </div>
  )
}

export default LocationFeaturedCentersCarousel
